import { createSvgIcon } from '@mui/material'

const createFeatherIcon = (path: React.ReactNode, displayName: string) => {
  return createSvgIcon(
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {path}
    </g>,
    displayName
  )
}

export const SyncIcon = createFeatherIcon(
  <>
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </>,
  'refresh-cw'
)

export const SyncDisabledIcon = createFeatherIcon(
  <>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="10" y1="15" x2="10" y2="9"></line>
    <line x1="14" y1="15" x2="14" y2="9"></line>
  </>,
  'pause-circle'
)

export const DoneIcon = createFeatherIcon(
  <>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </>,
  'check-circle'
)

export const WarningIcon = createFeatherIcon(
  <>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
    <line x1="12" y1="9" x2="12" y2="13"></line>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </>,
  'alert-triangle'
)

export const CloseIcon = createFeatherIcon(
  <>
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </>,
  'x'
)

export const AddIcon = createFeatherIcon(
  <>
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </>,
  'plus'
)

export const FilterListIcon = createFeatherIcon(
  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>,
  'filter'
)

export const SettingsIcon = createFeatherIcon(
  <>
    <circle cx="12" cy="12" r="3"></circle>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
  </>,
  'settings'
)

export const SaveAltIcon = createFeatherIcon(
  <>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </>,
  'download'
)

export const ExitToAppIcon = createFeatherIcon(
  <>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </>,
  'log-out'
)

export const WhatshotIcon = createFeatherIcon(
  <>
    <path d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z" />
    <path d="M12 18a3.75 3.75 0 00.495-7.467 5.99 5.99 0 00-1.925 3.546 5.974 5.974 0 01-2.133-1A3.75 3.75 0 0012 18z" />
  </>,
  'rewind'
)

//   <>
//     <polygon points="11 19 2 12 11 5 11 19"></polygon>
//     <polygon points="22 19 13 12 22 5 22 19"></polygon>
//   </>,
//   'rewind'
// )

export const WbSunnyIcon = createFeatherIcon(
  <>
    <circle cx="12" cy="12" r="5"></circle>
    <line x1="12" y1="1" x2="12" y2="3"></line>
    <line x1="12" y1="21" x2="12" y2="23"></line>
    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
    <line x1="1" y1="12" x2="3" y2="12"></line>
    <line x1="21" y1="12" x2="23" y2="12"></line>
    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
  </>,
  'sun'
)

export const NightsStayIcon = createFeatherIcon(
  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>,
  'moon'
)

export const FavoriteBorderIcon = createFeatherIcon(
  <>
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </>,
  'heart'
)

export const HelpOutlineIcon = createFeatherIcon(
  <>
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </>,
  'help-circle'
)

export const BarChartIcon = createFeatherIcon(
  <>
    <line x1="18" y1="20" x2="18" y2="10"></line>
    <line x1="12" y1="20" x2="12" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="14"></line>
  </>,
  'bar-chart-2'
)

export const AccountBalanceIcon = createFeatherIcon(
  <>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </>,
  'home'
)

export { default as AutoAwesomeIcon } from '@mui/icons-material/AutoAwesome'

export const AccountBalanceWalletIcon = createFeatherIcon(
  <>
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
    <line x1="1" y1="10" x2="23" y2="10"></line>
  </>,
  'credit-card'
)

export const SyncAltIcon = createFeatherIcon(
  <>
    <path d="M17 3L21 7M21 7L17 11M21 7H3M7 21L3 17M3 17L7 13M3 17H21" />
  </>,
  'transaction'
)

export const DeleteIcon = createFeatherIcon(
  <>
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </>,
  'trash'
)

export const LocalOfferOutlinedIcon = createFeatherIcon(
  <>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
    <line x1="7" y1="7" x2="7.01" y2="7"></line>
  </>,
  'tag'
)

export const DoneAllIcon = createFeatherIcon(
  <>
    <polyline points="9 11 12 14 22 4"></polyline>
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
  </>,
  'check-square'
)

export const MoreVertIcon = createFeatherIcon(
  <>
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="12" cy="5" r="1"></circle>
    <circle cx="12" cy="19" r="1"></circle>
  </>,
  'more-vertical'
)

export const VisibilityIcon = createFeatherIcon(
  <>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </>,
  'eye'
)

export { default as RestoreFromTrashIcon } from '@mui/icons-material/RestoreFromTrash'

export const ChevronRightIcon = createFeatherIcon(
  <polyline points="9 18 15 12 9 6"></polyline>,
  'chevron-right'
)

export const ChevronLeftIcon = createFeatherIcon(
  <polyline points="15 18 9 12 15 6"></polyline>,
  'chevron-left'
)

export const ChevronDownIcon = createFeatherIcon(
  <polyline points="6 9 12 15 18 9"></polyline>,
  'chevron-down'
)

export const ArrowBackIcon = createFeatherIcon(
  <>
    <line x1="19" y1="12" x2="5" y2="12"></line>
    <polyline points="12 19 5 12 12 5"></polyline>
  </>,
  'arrow-left'
)

export const ArrowUpwardIcon = createFeatherIcon(
  <>
    <line x1="12" y1="19" x2="12" y2="5"></line>
    <polyline points="5 12 12 5 19 12"></polyline>
  </>,
  'arrow-up'
)

export const ArrowDownwardIcon = createFeatherIcon(
  <>
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <polyline points="19 12 12 19 5 12"></polyline>
  </>,
  'arrow-down'
)

export const ArrowForwardIcon = createFeatherIcon(
  <>
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </>,
  'arrow-right'
)

export const EditIcon = createFeatherIcon(
  <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>,
  'edit-2'
)

export { default as DragIndicatorIcon } from '@mui/icons-material/DragIndicator'

export const EmojiFlagsIcon = createFeatherIcon(
  <>
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
    <line x1="4" y1="22" x2="4" y2="15"></line>
  </>,
  'flag'
)

export const NotesIcon = createFeatherIcon(
  <>
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
  </>,
  'message-circle'
)

export const MergeTypeIcon = createFeatherIcon(
  <>
    <path d="M7 9L12 4L17 9" />
    <path d="M6 20L10.83 15.172C11.58 14.42 12 13.4 12 12.34L12 4" />
    <path d="M18 20L14 16" />
  </>,
  'merge'
)

export const MoreHorizIcon = createFeatherIcon(
  <>
    <circle cx="12" cy="12" r="1"></circle>
    <circle cx="19" cy="12" r="1"></circle>
    <circle cx="5" cy="12" r="1"></circle>
  </>,
  'more-horizontal'
)

export const CalendarIcon = createFeatherIcon(
  <>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </>,
  'calendar'
)

export const GlobeIcon = createFeatherIcon(
  <>
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="2" y1="12" x2="22" y2="12"></line>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
  </>,
  'globe'
)

export const TagIcon = createFeatherIcon(
  <>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
    <line x1="7" y1="7" x2="7.01" y2="7"></line>
  </>,
  'tag'
)
